<div class="lvi-content">
    <div class="avatar" [nSelector]="{ liste: liste,item: data }">
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label">
                {{ data.mot }}
            </a>
        </div>
    </div>
</div>